import { render, staticRenderFns } from "./bottomPic.vue?vue&type=template&id=6c9f6d7c&scoped=true"
import script from "./bottomPic.vue?vue&type=script&lang=js"
export * from "./bottomPic.vue?vue&type=script&lang=js"
import style0 from "./bottomPic.vue?vue&type=style&index=0&id=6c9f6d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f6d7c",
  null
  
)

export default component.exports